import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reportingLeDataSessionAbortPath } from '~/consts/reportingLeDataApi';

import { request } from '~/services/common';

import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

import { reportingLeDataSessionQueryKeys } from './useGetReportingLeDataSession';
import { reportingLeDataSharedSessionQueryKeys } from './useGetReportingLeDataSharedSession';
import { reportingLeDataSessionsQueryKeys } from './useRecentReportingLeDataSessions';

export function useAbortReportingLeDataSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (sessionId: string) => {
      const url = resolveReportingLeDataUrl(reportingLeDataSessionAbortPath(sessionId));
      await request(url, { method: 'POST' });
    },
    onSuccess: (_data, sessionId) => {
      void queryClient.invalidateQueries({ queryKey: reportingLeDataSessionsQueryKeys.all });
      void queryClient.invalidateQueries({ queryKey: reportingLeDataSessionQueryKeys.detail(sessionId) });
      void queryClient.invalidateQueries({ queryKey: reportingLeDataSharedSessionQueryKeys.detail(sessionId) });
    },
  });
}
